import { Flow_0_0_2 } from '@flexus/core';

export const SIL_24: Flow_0_0_2 = {
	id: '24',
	name: 'work_in_progress',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for Team Leader to complete work'
		}
	},
	startNode: '',
	nodes: {}
};
